export interface AnimalForm {
  name: string;
  specie: string;
  breed: string;
  age: number;
  description?: string;
}

export const initialFormState: AnimalForm = {
  name: "Chulada brahman",
  specie: "cattle",
  breed: "Brahman",
  age: 3,
  description: "Chulada brahman",
};
